import { Injectable, OnDestroy, inject } from '@angular/core';
import { PrintPrices } from '@app/core/services/api/API.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilService } from '../../util.service';
import { map, take } from 'rxjs/operators';
import { PrintPricesService as PrintPricesApiService } from '@app/core/api/services';

@Injectable({
    providedIn: 'root'
})
export class PrintPricesService {
    private _printPrices$ = new BehaviorSubject<PrintPrices[]>([]);
    private _loading$ = new BehaviorSubject<boolean>(true);
    private printPrices: PrintPrices[] = [];
    private subscriptions: any[] = [];
    private _printPricesApiService = inject(PrintPricesApiService);

    private _isLoading = false;

    constructor(private _utilService: UtilService) {}

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    get printPrices$() {
        return this._printPrices$.asObservable();
    }

    get loading$() {
        return this._loading$.asObservable();
    }

    async listPrintPrices() {
        if (this._isLoading) {
            return;
        }

        const existingPrices = this._printPrices$.getValue();
        if (existingPrices && existingPrices.length > 0) {
            return;
        }

        this._isLoading = true;
        try {
            this._loading$.next(true);
            this.printPrices = await this.listPrintPricesBD();
        } catch (err) {
            this.printPrices = [];
        } finally {
            this._printPrices$.next(this.printPrices);
            this._loading$.next(false);
            this._isLoading = false;
        }
    }

    async findPrintPriceById(id: string): Promise<PrintPrices | undefined> {
        try {
            const printPrices = await this.printPrices$
                .pipe(take(1))
                .toPromise();
            return printPrices.find(printPrice => printPrice.id === id);
        } catch (error) {
            console.error('Error finding printPrice:', error);
            return undefined;
        }
    }

    printPricesByClient(idClient: string): Observable<PrintPrices[]> {
        return this.printPrices$.pipe(
            map((printPrices: PrintPrices[]) => {
                return printPrices.map((printPrice: PrintPrices) => printPrice);
            })
        );
    }

    private async listPrintPricesBD(): Promise<PrintPrices[]> {
        const items = await this._printPricesApiService.listPrintPrices();
        return this._utilService.sortJSON(items ?? [], 'identifier', 'asc');
    }
}
